import React from 'react';
import { Info } from 'lucide-react';
export function MaintenanceExplainer() {
  return <section className="py-20 px-6 md:px-12 bg-white" data-id="element-129">
      <div className="max-w-4xl mx-auto" data-id="element-130">
        <div className="text-center mb-12" data-id="element-131">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-132">
            Maintained Better Than Most Privately Owned Boats
          </h2>
          <p className="text-navy-600 text-lg leading-relaxed" data-id="element-133">
            Every Freedom Boat Club vessel follows a preventative maintenance
            schedule performed by in-house technicians. Boats are cleaned
            regularly, inspected between uses, and serviced throughout the
            season. Documentation is available upon request so buyers can
            purchase with confidence.
          </p>
        </div>

        <div className="bg-cream border-l-4 border-copper rounded-r-2xl p-8 md:p-10 shadow-sm relative overflow-hidden" data-id="element-134">
          <div className="absolute top-0 right-0 p-8 opacity-5" data-id="element-135">
            <Info className="w-32 h-32 text-copper" data-id="element-136" />
          </div>

          <div className="relative z-10" data-id="element-137">
            <div className="flex items-center gap-3 mb-4" data-id="element-138">
              <Info className="w-6 h-6 text-copper" data-id="element-139" />
              <h3 className="text-xl font-heading font-bold text-navy" data-id="element-140">
                Understanding Motor Hours
              </h3>
            </div>
            <p className="text-navy-700 leading-relaxed" data-id="element-141">
              Many boat buyers have concerns about motor hours. While hours are
              higher than a privately owned boat, modern outboards are built to
              last thousands of hours. With the average boat owner logging 50
              hours per year, even with a higher starting number, it will take
              decades for hours to become a concern. A well-maintained boat with
              higher hours can often be a more reliable purchase than one with
              lower hours and inconsistent service records.
            </p>
          </div>
        </div>
      </div>
    </section>;
}